import * as React from 'react';

// @ts-expect-error
import {BarGauge} from '../../../master-dashboard/dash-grid/dashes/quotas/bar-gauge';
import {calculateCurrentPercentToEndTime} from '../../../master-dashboard/dash-grid/dashes/quotas/quota';

type ActivityTableQuotaBarProps = {
    quota: number;
    percent: number;
    startTime?: number;
    endTime?: number;
};

export const ActivityTableQuotaBar = ({
    quota,
    percent,
    startTime,
    endTime,
}: ActivityTableQuotaBarProps) => {
    const currentPercentToEndTime = calculateCurrentPercentToEndTime(startTime, endTime);

    if (quota > 0) {
        return (
            <BarGauge
                hasQuota={true}
                percentComplete={percent}
                shouldRenderTodayLabel={false}
                currentPercentToEndTime={currentPercentToEndTime}
            />
        );
    }

    return <BarGauge hasQuota={false} />;
};
